import React, { useState, useEffect } from 'react';
import ManageProjects from './ManageProjects';
import ViewMessages from './ViewMessages';
import ManageBlog from './ManageBlog';
import Login from './Login';

export default function Dashboard() {
  const [activeTab, setActiveTab] = useState('projects');
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (token) {
      localStorage.setItem('adminToken', token);
    } else {
      localStorage.removeItem('adminToken');
    }
  }, [token]);

  const handleLogout = () => {
    setToken(null);
  };

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  if (!token) {
    return <Login onLogin={setToken} />;
  }

  const NavContent = () => (
    <>
      <nav className="flex-1 mt-6 px-4 space-y-2">
        <button 
          onClick={() => { setActiveTab('projects'); setIsSidebarOpen(false); }}
          className={`w-full text-left px-4 py-3 rounded-xl font-Inter transition-colors ${
            activeTab === 'projects' 
              ? 'bg-[#3aa1ff]/10 text-[#3aa1ff]' 
              : 'text-gray-400 hover:text-[#f1edfd] hover:bg-white/5'
          }`}
        >
          Manage Projects
        </button>
        <button 
          onClick={() => { setActiveTab('messages'); setIsSidebarOpen(false); }}
          className={`w-full text-left px-4 py-3 rounded-xl font-Inter transition-colors ${
            activeTab === 'messages' 
              ? 'bg-[#3aa1ff]/10 text-[#3aa1ff]' 
              : 'text-gray-400 hover:text-[#f1edfd] hover:bg-white/5'
          }`}
        >
          View Messages
        </button>
        <button 
          onClick={() => { setActiveTab('blog'); setIsSidebarOpen(false); }}
          className={`w-full text-left px-4 py-3 rounded-xl font-Inter transition-colors ${
            activeTab === 'blog' 
              ? 'bg-[#3aa1ff]/10 text-[#3aa1ff]' 
              : 'text-gray-400 hover:text-[#f1edfd] hover:bg-white/5'
          }`}
        >
          Manage Blog
        </button>
      </nav>

      <div className="p-4 border-t border-gray-800">
        <a
          href="/"
          className="block text-left px-4 py-3 rounded-xl font-Inter text-gray-400 hover:text-[#f1edfd] hover:bg-white/5 transition-colors mb-2"
        >
          ← Back to Site
        </a>
        <button 
          onClick={handleLogout}
          className="w-full text-left px-4 py-3 rounded-xl font-Inter text-red-400 hover:text-red-300 hover:bg-red-400/10 transition-colors flex items-center gap-2"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
          </svg>
          Logout
        </button>
      </div>
    </>
  );

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-[#131315]">
      {/* Mobile Header */}
      <div className="lg:hidden bg-[#1a1a1c] border-b border-gray-800 p-4 flex justify-between items-center z-50">
        <h1 className="text-xl font-bold font-Poppins text-[#f1edfd]">
          Admin<span className="text-[#3aa1ff]">Panel</span>
        </h1>
        <button onClick={toggleSidebar} className="text-[#f1edfd]">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
            <path strokeLinecap="round" strokeLinejoin="round" d={isSidebarOpen ? "M6 18L18 6M6 6l12 12" : "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"} />
          </svg>
        </button>
      </div>

      {/* Sidebar Navigation (Desktop) */}
      <div className="hidden lg:flex w-64 bg-[#1a1a1c] border-r border-gray-800 flex-col">
        <div className="p-6">
          <h1 className="text-2xl font-bold font-Poppins text-[#f1edfd]">
            Admin<span className="text-[#3aa1ff]">Panel</span>
          </h1>
        </div>
        <NavContent />
      </div>

      {/* Sidebar Navigation (Mobile Overlay) */}
      {isSidebarOpen && (
        <div className="lg:hidden fixed inset-0 bg-[#131315] z-40 pt-16 flex flex-col animate-fade-in">
          <NavContent />
        </div>
      )}

      {/* Main Content Area */}
      <div className="flex-1 overflow-auto p-4 lg:p-8">
        <div className="max-w-5xl mx-auto">
          {activeTab === 'projects' && <ManageProjects />}
          {activeTab === 'messages' && <ViewMessages />}
          {activeTab === 'blog' && <ManageBlog />}
        </div>
      </div>
    </div>
  );
}
